import { LineItem } from '../../hooks/useCart/cart.rest';

export const hasError = (items: LineItem[]) =>
  items.some(
    item =>
      item.type === 'cart_items' && (!item.attributes.isProductAvailable || item.attributes.error)
  );
